import {h, Fragment} from "preact"
import { useAppState, useSelectedFiltersCount, useSort } from "@nosto/preact"
import { useState, useEffect } from "preact/hooks"
import { sortOptions } from "../config"
import Sidebar from "./Sidebar"
import Icon from "./elements/Icon"
import Select from "./elements/Select"

function ToggleMobileSidebarButton({ selectedFiltersCount, className, onChange}) {
    // const [isChecked, setIsChecked] = useState(false);
    const id = "toggle-mobile-sidebar"

    return (
        <>
        <input type="checkbox" id={id} class="ns-facet-sidebar-toggle ns-d-none" onChange={onChange}/>
        <label
            for={id}
            className={`ns-act-btn CollectionToolbar__Item CollectionToolbar__Item--filter Heading Text--subdued u-h6  ns-filters ns-d-inline-flex ns-justify-content-center ns-text-align-center ns-align-items-center ${className}`}
        >
            
           {`Filter + `}
            {selectedFiltersCount > 0 && (
                <span className="ns-total-count Text--subdued">
                    ({selectedFiltersCount})
                </span>
            )}
        </label>
        </>
    )
}

export default function Toolbar({ mobile }) {
    const { loading, query, response, pageType } = useAppState()
    const { activeSort, setSort } = useSort(sortOptions)
    const selectedFiltersCount = useSelectedFiltersCount()

    const handleSortChange = event => {
        setSort(event.target.value)
    }

    const docCount = response.products?.total ?? 0

    const totalSummary = pageType === "category" ? `${docCount} products` : `'${query.query}' - ${docCount} results`

    const options = sortOptions.map(o => ({ value: o.id, label: o.value.name }))

    const [isChecked, setIsChecked] = useState(false);

    const handleInputChange = (event) => {
        setIsChecked(event.target.checked);
    };

    useEffect(() => {
        if (isChecked) {
            document.documentElement.classList.add('no-scroll');
        } else {
            document.documentElement.classList.remove('no-scroll');
        }
        return () => {
            document.documentElement.classList.remove('no-scroll');
        };
    }, [isChecked]);

    return (
        <div
            class={
                // mobile ?
                    "ns-mobile-header-controls CollectionToolbar CollectionToolbar--top CollectionToolbar--reverse ns-d-flex ns-flex-wrap align-center ns-justify-content-between"
                    // : "ns-header-controls ns-d-none ns-flex-wrap align-center ns-justify-content-between ns-d-md-flex ns-pt-o ns-pr-2 ns-pb-1 ns-pl-2"
            }
            style={isChecked ? "z-index: 1052" : ""}
            // style={loading ? "opacity: 0.3; justify-content: end !important;" : ""}
        >
            {/* {!loading && (
                <span
                    class="ns-d-inline ns-text-align-center ns-order-3 ns-d-md-block ns-order-md-first ns-align-self-md-center ns-color-black"
                    data-nosto-element="totalResults"
                >
                    { totalSummary }
                </span>
            )} */}
            <div
                class={
                    // mobile ?
                        "ns-d-flex CollectionToolbar__Group ns-w-100"
                        // : "ns-d-flex ns-flex-wrap ns-justify-content-between ns-d-md-block"
                }
            >
                {/* {mobile && ( */}
                    <>
                        <ToggleMobileSidebarButton onChange={e => handleInputChange(e)} selectedFiltersCount={selectedFiltersCount} />
                        <Sidebar mobile />
                    </>
                {/* )} */}
                {/* <Select
                    value={activeSort}
                    onChange={e => handleSortChange(e)}
                    className="ns-selection-dropdown-sort-menu"
                    options={options}
                /> */}
            </div>
        </div>
    )
}
